import React, { useEffect } from 'react';
import { VegaLoadingIndicator } from '@heartlandone/vega-react';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import { getFromlocalStorage } from 'Chores/utils';
import { FE_ROUTES } from 'Chores/Api';

const loadingStyle = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  right: '50%'
};

const BackToSharkTankAfterLogin = () => {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  useEffect(() => {
    if (keycloak.authenticated) {
      const loginRedirect = getFromlocalStorage('loginRedirect');
      const params = new URLSearchParams(window.location.search);
      const callbackto = params.get('callbackto');
      if (callbackto) {
        try {
          const decodedUrl = decodeURIComponent(callbackto);
          const parsedUrl = new URL(decodedUrl);
          const activityHubOrigin = new URL(process.env.REACT_APP_ACTIVITY_HUB).origin;
          if (parsedUrl.origin === activityHubOrigin) {
            const existingParams = parsedUrl.searchParams;
            existingParams.set('token', keycloak.token);
            const finalUrl = `${parsedUrl.origin}${parsedUrl.pathname}?${existingParams.toString()}${parsedUrl.hash}`;
            window.location.href = finalUrl;
            return;
          }
        } catch (err) {
          console.log('Invalid callbackto URL');
        }
      }
      if (!loginRedirect) {
        navigate(FE_ROUTES.HOME);
      } else {
        navigate(loginRedirect.pathname + loginRedirect.search);
      }
    }
  }, [keycloak.authenticated]);

  return <VegaLoadingIndicator style={loadingStyle} label="Loading"/>;
};

export default BackToSharkTankAfterLogin;
